import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash/fp';
import { connect } from 'react-redux';
import cns from 'classnames';

import FavoriteIcon from 'components/FavoriteIcon';
import cn from './styles.local.less';
import * as actions from './actions';

class FavoriteSwitcher extends PureComponent {
  static propTypes = {
    adId: PropTypes.string.isRequired,
    className: PropTypes.string,
    isFavorite: PropTypes.bool,
    toggleAdFavorite: PropTypes.func.isRequired,
    onToggleAdFavoriteClick: PropTypes.func,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    isFavorite: false,
    onToggleAdFavoriteClick: noop,
    onClick: noop,
  };

  state = {
    isFavorite: this.props.isFavorite,
    isAnimating: false,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.isFavorite !== nextProps.isFavorite) {
      this.setState({ isFavorite: nextProps.isFavorite });
    }
  }

  toggleAdFavorite = (isFavorite) => {
    const { adId, toggleAdFavorite, onToggleAdFavoriteClick } = this.props;

    toggleAdFavorite(adId, isFavorite)
      .then((response) => onToggleAdFavoriteClick(adId, isFavorite, response))
      .catch(() => this.setState({ isFavorite: this.props.isFavorite }));
  };

  handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const { onClick, isFavorite } = this.props;

    if (isFavorite) {
      this.setState({ isFavorite: false, isAnimating: false }, () => {
        onClick(false);
        this.toggleAdFavorite(false);
      });
    } else {
      this.setState({ isFavorite: true, isAnimating: true }, () => {
        onClick(true);
        this.toggleAdFavorite(true);
      });
    }
  };

  render() {
    const { className } = this.props;
    const { isAnimating, isFavorite } = this.state;

    return (
      <button
        className={cns(cn.root, className, { [cn.filled]: isFavorite })}
        data-qa-selector="favorite-btn"
        onClick={this.handleClick}
      >
        <FavoriteIcon
          className={cns(cn.icon, { [cn.beatingAnimation]: isAnimating })}
          isFilled={isFavorite}
        />
      </button>
    );
  }
}

export default connect(null, actions)(FavoriteSwitcher);
